<template>
  <div>
    <AddRouteDestination ref="add" />
    <TransferRouteDriver ref="transfer" />
    <RemoveRouteDestination ref="remove" />
    <el-dialog
      title="Visualizar Mapa"
      :append-to-body="true"
      center
      fullscreen
      :visible.sync="map"
      width="80%"
    >
      <TravelMap
        ref="map"
        :lat="lat"
        :lng="lng"
        :markers="markers"
        v-if="map"
      />
    </el-dialog>
    <el-card shadow="always">
      <el-page-header
        back="back"
        title
        content="Motorista RealTime"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" :inline="true" ref="ruleForm">
        <el-row :gutter="5">
          <el-col :span="12">
            <el-form-item :label="$t('data')" prop="day">
              <el-date-picker
                v-model="ruleForm.day"
                type="date"
                format="dd/MM/yyyy"
              ></el-date-picker>
            </el-form-item>
            <el-button size="mini" type="info" @click="fetch()"
              >Filtrar</el-button
            >&nbsp;
          </el-col>
          <el-col :span="12" v-if="tableDrivers.length > 0">
            <el-form-item :label="$t('motorista')" prop="driver">
              <el-select
                ref="driver"
                v-model="ruleForm.driver"
                filterable
                @change="changeDriver()"
              >
                <el-option key="" label="Todos" value=""></el-option>
                <el-option
                  v-for="row of tableDrivers"
                  :key="row.id"
                  :label="row.name"
                  :value="row.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="ended">Ver rotas finalizadas</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-card shadow="always">
          <el-descriptions
            class="margin-top"
            :title="tableItem.name"
            :column="3"
            border
            v-for="tableItem of tableData.filter(
              (x) => ended || (!ended && x.pendency !== 'ended')
            )"
            :key="tableItem.pendencyId"
          >
            <template slot="extra">
              <span
                v-if="
                  tableItem.pendency !== 'ended' &&
                  tableItem.status === 'online'
                "
              >
                <i
                  class="fa fa-circle"
                  aria-hidden="true"
                  style="color: green"
                ></i
                >Online
              </span>
              <span v-else-if="tableItem.pendency !== 'ended'">
                <i
                  class="fa fa-circle"
                  aria-hidden="true"
                  style="color: red"
                ></i
                >Offline
              </span>
              &nbsp;
              <el-dropdown @command="open">
                <el-button type="primary"
                  >Ações&nbsp;<i class="el-icon-arrow-down el-icon--right"></i
                ></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="tableItem.pendency !== 'ended'"
                    :command="`transfer@${tableItem.pendencyId}`"
                    >Transferir motorista</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="tableItem.pendency !== 'ended'"
                    :command="`add@${tableItem.pendencyId}`"
                    >Adicionar cliente</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="tableItem.pendency !== 'ended'"
                    :command="`remove@${tableItem.pendencyId}`"
                    >Remover cliente</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="`route.realtime.history@${tableItem.pendencyId}`"
                    >Histórico</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <el-descriptions-item :span="2">
              <template slot="label">
                <i class="el-icon-user"></i>
                Status
              </template>
              <span v-if="tableItem.pendency === 'pending'">
                <i
                  class="fa fa-exclamation-triangle"
                  aria-hidden="true"
                  style="color: orange"
                ></i>
                Aguardando motorista iniciar a rota
              </span>
              <span v-else-if="tableItem.pendency === 'ended'">
                <i
                  class="fa fa-check-circle-o"
                  aria-hidden="true"
                  style="color: green"
                ></i>
                Rota já finalizada pelo motorista
              </span>
              <span v-else-if="tableItem.pendency === 'report'">
                <i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                  style="color: red"
                ></i>
                {{ tableItem.report }}<br />
                Motorista indo até o próximo destino
              </span>
              <span v-else-if="tableItem.pendency === 'current'">
                <i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                  style="color: green"
                ></i>
                Motorista indo até o destino
              </span>
              <el-link
                class="right"
                type="primary"
                @click="
                  route(tableItem.started, tableItem.geometry, tableItem.marker)
                "
                >Ver rota</el-link
              >
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-mobile-phone"></i>
                Telefone
              </template>
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">
                <i class="el-icon-location-outline"></i>
                Localização atual
              </template>
              {{ tableItem.location }}
              <el-link
                class="right"
                type="primary"
                @click="view(tableItem.geometry.lat, tableItem.geometry.lng)"
                >Ver mapa</el-link
              >
            </el-descriptions-item>
            <el-descriptions-item :span="3">
              <template slot="label">
                <i class="el-icon-location-outline"></i>
                Destino
              </template>
              {{ tableItem.marker.formatted }}
              <el-link
                class="right"
                type="primary"
                @click="view(tableItem.marker.lat, tableItem.marker.lng)"
                >Ver mapa</el-link
              >
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-tickets"></i>
                Chegar as
              </template>
              <el-tag size="small">{{ tableItem.marker.time }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-tickets"></i>
                Estimativa
              </template>
              <el-tag type="info" size="small">{{ tableItem.duration }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item :labelStyle="labelStyle(tableItem.schedule)">
              <template slot="label">
                <i class="el-icon-tickets"></i>
                Previsão
              </template>
              <el-tag size="small">{{ tableItem.arrive }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-office-building"></i>
                Cliente
              </template>
              {{ tableItem.marker.name }}
            </el-descriptions-item>
          </el-descriptions>
        </el-card>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { RouteService } from "@/services/umov/route.services";
import { DriversService } from "@/services/customers/drivers.services";
import { TeamService } from "@/services/umov/team.services";
import TravelMap from "./components/TravelMap";
import TransferRouteDriver from "./components/TransferRouteDriver.vue";
import AddRouteDestination from "./components/AddRouteDestination.vue";
import RemoveRouteDestination from "./components/RemoveRouteDestination.vue";

import moment from "moment";
import "moment/locale/pt-br";
import { mapGetters } from "vuex";

export default {
  name: "RouteRealTime",
  components: {
    TravelMap,
    TransferRouteDriver,
    AddRouteDestination,
    RemoveRouteDestination,
  },
  computed: {
    ...mapGetters("socket", ["socket"]),
  },
  mounted() {
    const vm = this;
    const interval = setInterval(() => {
      if (vm.socket) {
        vm.setup();
        clearInterval(interval);
      }
    }, 1000);
    this.fetch();
  },
  data() {
    return {
      ended: false,
      tableDrivers: [],
      tableData: [],
      markers: [],
      lat: 0,
      lng: 0,
      map: false,
      ruleForm: {
        day: new Date(),
        driver: "",
      },
    };
  },
  methods: {
    updateStatus(id, status) {
      for (let i = 0; i < vm.tableData.length; i++) {
        if (vm.tableData[i].driverId === id) {
          vm.tableData[index].status = status;
        }
      }
    },
    setup() {
      const vm = this;
      vm.socket.on("driver-offline", (data) => {
        console.log("driver.offline", data);
        vm.updateStatus(data, "offline");
      });

      vm.socket.on("driver-online", (data) => {
        console.log("driver.onoff", data);
        vm.updateStatus(data, "online");
      });

      vm.socket.on("driver-started", (data) => {
        const index = vm.tableData.findIndex((x) => x.pendencyId === data.id);
        console.log("driver.started", data, index);
        if (index !== -1) vm.tableData[index].pendency = data.pendency;
      });

      vm.socket.on("driver-report", (data) => {
        console.log("driver-report", data);
        const index = vm.tableData.findIndex((x) => x.pendencyId === data.id);
        console.log("tableData", index);
        if (index !== -1) {
          vm.tableData[index].report =
            "Motorista reportou um erro no ultimo cliente " + data.reason;
          vm.tableData[index].pendency = "report";
        }
      });

      vm.socket.on("driver-updated", (data) => {
        console.log("driver.updated", data);
        const index = vm.tableData.findIndex((x) => x.pendencyId === data.id);
        console.log("tableData", index);
        if (index !== -1) {
          if (data.pendency) {
            vm.tableData[index].pendency = data.pendency;
          } else if (data.location.location) {
            vm.tableData[index].location = data.location.location;
            vm.tableData[index].duration = data.location.duration;
            vm.tableData[index].arrive = data.location.arrive;
            vm.tableData[index].marker.status = data.location.marker.status;
            vm.tableData[index].geometry.lat = data.location.geometry.lat;
            vm.tableData[index].geometry.lng = data.location.geometry.lng;
          }
        }
      });
    },
    open(action) {
      const handle = action.split("@");
      console.log("open", handle);
      if (this.$refs[handle[0]]) this.$refs[handle[0]].open(handle[1]);
      else {
        this.$router.push({
          name: handle[0],
          query: {
            id: handle[1],
          },
        });
      }
    },
    labelStyle(schedule) {
      return schedule === "late"
        ? { "background-color": "#FDE2E2" }
        : { "background-color": "#E1F3D8" };
    },
    route(started, actual, marker) {
      const vm = this;
      vm.markers = [];
      if (started) {
        vm.markers.push({
          geometry: {
            customer: "1",
            lat: +started.lat,
            lng: +started.lng,
          },
          address: {
            geometry: {
              customer: "1",
              lat: +started.lat,
              lng: +started.lng,
            },
          },
        });
      }
      vm.markers.push({
        geometry: {
          customer: "2",
          lat: +actual.lat,
          lng: +actual.lng,
        },
        address: {
          geometry: {
            lat: +actual.lat,
            lng: +actual.lng,
          },
        },
      });
      vm.markers.push({
        geometry: {
          customer: "3",
          lat: +marker.lat,
          lng: +marker.lng,
        },
        address: {
          geometry: {
            lat: +marker.lat,
            lng: +marker.lng,
          },
        },
      });
      console.log("vm.markers", vm.markers);
      setTimeout(() => {
        vm.map = true;
      }, 200);
    },
    view(lat, lng) {
      const vm = this;
      this.lat = +lat;
      this.lng = +lng;
      this.markers = [];
      this.markers.push({
        geometry: {
          customer: "1",
          lat: +lat,
          lng: +lng,
        },
        address: {
          geometry: {
            customer: "1",
            lat: +lat,
            lng: +lng,
          },
        },
      });
      this.markers.push({
        geometry: {
          customer: "2",
          lat: +lat,
          lng: +lng,
        },
        address: {
          geometry: {
            lat: +lat,
            lng: +lng,
          },
        },
      });
      setTimeout(() => {
        vm.map = true;
      }, 200);
    },
    back() {
      this.$router.push({ name: "home" });
    },
    fetch() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.day).format("YYYY-MM-DD");
      
      // DriversService.list()
      //   .then((response) => {
      //     vm.tableDrivers = response.sort((a, b) => a.name.localeCompare(b.name));
      //   })
      //   .catch((error) => {
      //     return this.$message({ type: "error", duration: 5000, message: error });
      //   });
        
      RouteService.realtime(s)
        .then((response) => {
          for (const itemData of response) {
            const driverData = vm.tableDrivers.find(
              (x) => x.id === itemData.id
            );
            console.log('itemData ==>',  itemData);
            if (!driverData) {
              vm.tableDrivers.push({
                id: itemData.id,
                name: itemData.name,
              });
            }
          }
          vm.tableData = response;
          console.log(vm.tableData);
          
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
};
</script>

<style>
.late {
  background: #fde2e2;
}
.ontime {
  background: #e1f3d8;
}
.margin-top {
  margin-top: 20px;
}
</style>
